import { useState } from 'react';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300">
      <nav className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 md:w-11 md:h-11 bg-primary-500 rounded-2xl flex items-center justify-center transform -rotate-3 group-hover:rotate-0 transition-transform duration-300">
              <span className="text-background-50 font-heading text-xl font-bold">51</span>
            </div>
            <span className="text-foreground-950 font-heading text-lg md:text-xl whitespace-nowrap">
              黑料不打烊
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 5).map((cat) => (
              <a
                key={cat.slug}
                href={`/category/${cat.slug}`}
                className="px-4 py-2 text-foreground-600 hover:text-foreground-950 text-sm font-label transition-colors duration-200 rounded-full hover:bg-background-100 whitespace-nowrap"
              >
                {cat.name}
              </a>
            ))}
            <div className="relative group">
              <button className="px-4 py-2 text-accent-500 hover:text-accent-400 text-sm font-label transition-colors duration-200 rounded-full whitespace-nowrap flex items-center gap-1">
                <i className="ri-flashlight-line"></i>
                更多入口
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full right-0 mt-1 w-44 bg-background-100 border border-background-200 rounded-2xl overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 shadow-lg">
                {categories.slice(5).map((cat) => (
                  <a
                    key={cat.slug}
                    href={`/category/${cat.slug}`}
                    className="flex items-center gap-2 px-4 py-2.5 text-foreground-600 hover:text-foreground-950 hover:bg-background-200 transition-colors duration-150 text-sm"
                  >
                    <i className={`${cat.icon} w-4 h-4`}></i>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="/about"
              className="hidden md:flex items-center gap-1.5 px-4 py-2 text-foreground-500 hover:text-foreground-950 text-sm font-label transition-colors duration-200 whitespace-nowrap"
            >
              <i className="ri-information-line"></i>
              关于我们
            </a>
            <button className="hidden md:flex btn-primary text-sm px-6 py-2.5 shadow-lg">
              <i className="ri-send-plane-line mr-1.5"></i>
              我要爆料
            </button>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-1">
            {categories.map((cat) => (
              <a
                key={cat.slug}
                href={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-4 py-3 text-foreground-600 hover:text-foreground-950 hover:bg-background-200 rounded-xl transition-colors duration-150"
                onClick={() => setMobileOpen(false)}
              >
                <i className={`${cat.icon} w-5 h-5`}></i>
                <span>{cat.name}</span>
              </a>
            ))}
            <div className="border-t border-background-200 my-2"></div>
            <a
              href="/about"
              className="flex items-center gap-3 px-4 py-3 text-foreground-500 hover:text-foreground-950 hover:bg-background-200 rounded-xl transition-colors duration-150"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-information-line w-5 h-5"></i>
              <span>关于我们</span>
            </a>
            <button className="btn-primary mt-2 flex items-center justify-center gap-2">
              <i className="ri-send-plane-line"></i>
              我要爆料
            </button>
          </div>
        </div>
      )}
    </header>
  );
}